import React, { useEffect } from 'react';
import SidebarMenu from '../sidebar/sidebar'
import './AdminPage.css'
import { useLocation, useNavigate } from 'react-router-dom';
// import Role from '../Role/role';
import logo from '../../logo.png';


const AdminPage = () => {

    const location = useLocation();
    const role = location.state;
    
    const navigate = useNavigate();
    useEffect(() => {
        const lastVisitedPage = localStorage.getItem('lastVisitedDoctorPage');
        if (lastVisitedPage) {
          navigate(`/doctorPage/${lastVisitedPage}`);
        }
      }, [navigate]);
    // useEffect(() => {
    //     if (!localStorage.getItem('email')) {
    //         navigate('/');
    //     }
    // }, []);

    return (
        <>
            <div className='AdminPageContainer' style={{ direction: "rtl" }}>
                <SidebarMenu role={role} />
             
                <div className='logo-cont'>
                    <img className='logo-img-home' alt='logo' src={logo} />
                    <div>מוקד רפואי אלעד</div>
                    <div>ניהול תורים</div>
                </div>
                {/* <Role /> */}

            </div>
        </>

    );
};

export default AdminPage;
